import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordMatchValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.get('userPasswordControl')?.value;
    const repeatPassword = control.get('userConfirmPasswordControl')?.value;

    const passwordCriteria =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;

    if (!password || !repeatPassword) {
      return null; // Si no hay valores, no valida
    }

    if (password !== repeatPassword) {
      return { passwordMismatch: true }; // Contraseñas no coinciden
    }

    if (!passwordCriteria.test(password)) {
      return { invalidPassword: true }; // Contraseña no cumple con los criterios
    }

    return null; // Contraseñas coinciden y cumplen con los criterios
  };
}
